import localforage from "localforage";
import * as http from "modules/app/utils/http";
import moment from "moment";

function notNeedUpdate(foundedContact, currentContact) {
  const lastMessageFirebase = foundedContact?.last_message;
  const lastMessageAPI = currentContact?.messages
    ? currentContact?.messages[currentContact?.messages.length - 1]
    : null;

  // IF DON'T HAVE CHANGES IN THE LAST MESSAGE DO NOT NEED UPDATE
  // IF DON'T HAVE CHANGES IN UPDATE_AT CONTACT DO NOT NEED UPDATE

  return (
    lastMessageAPI?.body == lastMessageFirebase?.body &&
    lastMessageFirebase?.ack?.email?.status ==
      lastMessageAPI?.ack?.email?.status &&
    lastMessageFirebase?.ack?.whatsapp?.status ==
      lastMessageAPI?.ack?.whatsapp?.status &&
    currentContact?.updated_at == foundedContact?.updated_at
  );
}

export function customerProxy(customer) {
  return new Promise(async (resolve, _reject) => {
    const result = await localforage.getItem(`customer-${customer.id}`);

    if (!!result && notNeedUpdate(customer, result)) {
      return resolve({ ...result });
    }

    const customerResponse = await http.getCustomer(customer);
    const messagesResponse = await http.getMessages(customer.id, 1);
    const sortedMessages = messagesResponse.data.reverse();

    const resultFromAPI = {
      ...customerResponse,
      messages: [...sortedMessages],
      totalPages: Number(messagesResponse?.headers["total-pages"]),
      currentContactMessagesCount: customerResponse?.messages?.length,
    };

    localforage
      .setItem(`customer-${resultFromAPI.id}`, resultFromAPI)
      .then(function () {
        return resolve(resultFromAPI);
      });
  });
}

export function registerCustomers(id, contacts) {
  return localforage.setItem(`customers-list-${id}`, contacts);
}

export function recoveryCustomers(id) {
  return new Promise(async (resolve, _reject) => {
    localforage
      .getItem(`customers-list-${id}`)
      .then((result) => resolve(result));
  });
}

export function registerTotalTabs(id, totals) {
  return localforage.setItem(`customers-total-tabs-${id}`, totals);
}

export function recoveryTotalTabs(id) {
  return localforage.getItem(`customers-total-tabs-${id}`);
}

export default {
  recoveryCustomers,
  registerCustomers,
  customerProxy,
};
